__turbopack_context__.v({
  "collapse": "NavigationDropdown-module__s0LZwW__collapse",
  "isActive": "NavigationDropdown-module__s0LZwW__isActive",
  "isCurrentPage": "NavigationDropdown-module__s0LZwW__isCurrentPage",
  "nav": "NavigationDropdown-module__s0LZwW__nav",
  "navItem": "NavigationDropdown-module__s0LZwW__navItem",
  "parentNavItem": "NavigationDropdown-module__s0LZwW__parentNavItem",
});
